<template>
  <div v-if="show" class="normal-dialog">
    <div class="black-bg" />
    <div v-if="loadingBox" class="loading-box">
      <div class="loading-icon">
        <span />
      </div>
    </div>
    <div class="template-box" :class="{ long: stage > 1 }">
      <div class="header">
        <div
          v-if="
            (stage !== 1 && stage !== 4 && diagnosisInfo.type !== 3) ||
            (diagnosisInfo.type == 3 && stage == 3)
          "
          class="back-icon"
          @click="backHandler"
        >
          <i class="iconfont icon-more-left" />
        </div>
        <div class="logo" :class="`logo-${$store.state.locale}`">
          <img v-lazy-load :data-src="logoUrl" />
        </div>
        <div class="operate-dialog-icon close-icon" @click="closeHandler">
          <div class="close-icon">
            <img v-lazy-load data-src="~assets/web/images/login/close-icon@2.png" />
          </div>
          <div class="close-icon hover-close-icon">
            <img v-lazy-load data-src="~assets/web/images/login/hover-close-icon@2.png" />
          </div>
        </div>
      </div>
      <template v-if="stage === 1">
        <div class="t1-title">Please fill in your child's information.</div>
        <template v-if="!isNew">
          <div class="stu-list">
            <span
              v-for="(item, index) in oldStuData"
              :key="item.uid"
              class="stu-box"
              :class="{ on: lvShow === index }"
              @click="changeStu(item, index, false)"
            >
              <img v-lazy-load :data-src="item.avatar" />{{ item.firstName || item.nickName }}
            </span>
            <span
              v-if="oldStuData.length < 6"
              class="stu-box new"
              :class="{ on: lvShow == oldStuData.length }"
              @click="changeStu({}, oldStuData.length - 1, true)"
            >
              <i class="icon" />New student
            </span>
          </div>
        </template>
        <div class="pub-box">
          <p>
            <span class="half">
              <el-input
                v-model="stuParms.firstName"
                :placeholder="'Child’s first name'"
                maxlength="32"
              />
            </span>
            <span class="half">
              <el-input
                v-model="stuParms.lastName"
                :placeholder="'Child’s last name'"
                maxlength="32"
              />
            </span>
          </p>
          <p>
            <el-select
              v-model="stuParms.gradeId"
              :placeholder="$t('evaluation.gradePlaceholder')"
              :multiple="false"
              popper-class="normal-grace-dropdown"
              @change="changeHandler"
            >
              <el-option
                v-for="item in gradeList"
                :key="String(item.gradeId)"
                :label="item.gradeName"
                :value="String(item.gradeId)"
              />
            </el-select>
          </p>
          <p v-if="schoolCode !== '4401'">
            <el-select
              v-model="stuParms.campus"
              :placeholder="'Choose campus'"
              :multiple="false"
              popper-class="normal-grace-dropdown"
              no-data-text="Please select campus first."
              @change="changeCampus"
            >
              <el-option
                v-for="item in campusList"
                :key="String(item.venueId)"
                :label="item.venueName"
                :value="String(item.venueId)"
              />
            </el-select>
          </p>
          <p v-if="schoolCode !== '4401'">
            <el-select
              v-model="stuParms.learningGoalIds"
              :placeholder="'Math Learning Goals'"
              :multiple="true"
              popper-class="normal-grace-dropdown"
              class="math-learning-goals-select"
            >
              <el-option
                v-for="item in objectivesList"
                :key="String(item.id)"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </p>
          <p>
            <el-input
              v-model="stuParms.phoneNumber"
              class="phone-code-input"
              :placeholder="'Contact number'"
            >
              <el-select
                id="update_phone_select"
                slot="prepend"
                v-model="stuParms.phoneAreaCode"
                :popper-append-to-body="false"
                class="phone-code-select"
                popper-class="phone-area-code-dropdown phone-area-code-dropdown-x normal-grace-dropdown text-left"
                value-key="countryCode"
              >
                <el-option
                  v-for="code in phoneCodeList"
                  :key="code.countryCode"
                  class="phone-area-code-option"
                  :label="`+${code.value}`"
                  :value="code"
                >
                  <div class="select-line">
                    <div class="area-name">
                      {{ code.countryName }}
                    </div>
                    <div class="area-code">+{{ code.value }}</div>
                  </div>
                </el-option>
              </el-select>
            </el-input>
          </p>
          <p>
            <el-input v-model="stuParms.email" :placeholder="'Contact email'" />
          </p>
          <p class="btn-box">
            <span v-show="existCalendly" class="s1" @click="toLv2">Schedule Evaluation on Calendly</span>
            <span v-show="existExam" :class="[{s2: existCalendly && existExam , s1: !existCalendly}]" @click="toZd">
              <span v-if="loading" class="loading" />
              {{ $t("evaluation.onLineText") }}
            </span>
          </p>
        </div>
      </template>
      <template v-if="stage === 2">
        <div v-if="diagnosisInfo.type == 3" class="t1-title">
          How should we contact you for this free consultation?
        </div>
        <div v-else class="t1-title">
          Your evaluation will be conducted via:
        </div>
        <div
          class="zd-main"
          :class="{
            'zd-main-v1': stuParms.campus == -1 && diagnosisInfo.type !== 3,
          }"
        >
          <div
            class="pub-zd zoom"
            :class="{ on: zdNow == 1 }"
            @click="
              () => {
                zdNow = 1;
              }
            "
          >
            <div class="img-box">
              <img
                v-lazy-load data-src="https://download-pa-s3.thethinkacademy.com/message/picture/8601/20240612/1718183269079UVVaBFYuve.png"
              />
            </div>
            <div class="change-btn">
              <span class="icon" />
              <p class="txt">
                Zoom meeting<br /><span
                  >Our Math Expert will set a free zoom meeting consultant with
                  you</span
                >
              </p>
            </div>
          </div>
          <div
            v-if="String(stuParms.campus) !== '-1' && diagnosisInfo.type !== 3"
            class="pub-zd online"
            :class="{ on: zdNow == 2 }"
            @click="
              () => {
                zdNow = 2;
              }
            "
          >
            <div class="map-box">
              <div
                v-if="
                  !userNetworkInfo.isMainland &&
                  !userNetworkInfo.isChina &&
                  userNetworkInfo.isMainland !== null &&
                  mapData[stuParms.campus]
                "
                class="map-if"
              >
                <iframe
                  v-lazy-load :data-src="mapData[stuParms.campus].iframe"
                  width="340"
                  height="160"
                  style="border: 0"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                />
              </div>
              <img
                v-else
                class="map"
                v-lazy-load data-src="https://download-pa-s3.thethinkacademy.com/message/picture/8601/20240612/17181841241692zhOwhtxQu.png"
              />
            </div>
            <div class="change-btn">
              <span class="icon" />
              <p class="txt">
                {{
                  mapData[stuParms.campus] ? mapData[stuParms.campus].name : ""
                }}<br /><span>{{
                  mapData[stuParms.campus]
                    ? mapData[stuParms.campus].adress
                    : ""
                }}</span>
              </p>
            </div>
          </div>
          <div
            v-if="diagnosisInfo.type == 3"
            class="pub-zd zj"
            :class="{ on: zdNow == 3 }"
            @click="
              () => {
                zdNow = 3;
              }
            "
          >
            <div class="img-box">
              <img
                v-lazy-load data-src="https://download-pa-s3.thethinkacademy.com/message/picture/8601/20240612/17181834366858lDguVbfyl.png"
              />
            </div>
            <div class="change-btn">
              <span class="icon" />
              <p class="txt">
                Phone call<br /><span
                  >Our Math Expert will make a phone call with you</span
                >
              </p>
            </div>
          </div>
        </div>
        <div class="zd-big-btn">
          <span @click="tolv3">Next</span>
        </div>
      </template>
      <div v-show="stage === 3" class="schedulePage">
        <div class="bw-box">
          <div id="SAMPLEdivID" />
        </div>
        <div class="stage3-bottom">
          No suitable time slots? Call us at <span>{{ venuePhone }}</span> or
          send an email to <span>{{ venueEmail }}</span>
        </div>
        <div v-if="stage3Loading" class="stage3-loading">
          <div class="stage3-loading-icon">
            <span />
          </div>
          <span class="stage3-loading-text">loading...</span>
        </div>
        <div v-if="stage3Error" class="stage3-error">
          <div class="stage3-error-img">
            <img
              v-lazy-load data-src="~assets/web/images/appointmentDiagnosis/stage3-null.png"
            />
          </div>
          <div class="stage3-error-text">Failed to load</div>
          <div class="stage3-error-btn" @click="zoomHd(csUrl, 'retry')">
            Retry
          </div>
        </div>
        <div v-if="stage3Null" class="stage3-null">
          <div class="stage3-null-img">
            <img
              v-lazy-load data-src="~assets/web/images/appointmentDiagnosis/stage3-null.png"
            />
          </div>
          <div class="stage3-null-text">
            {{ $t("common.stage3Null") }}
          </div>
          <div class="stage3-null-btn" @click="toZd">
            Start online evaluation now
          </div>
        </div>
      </div>
      <template v-if="stage === 4">
        <div class="succ-box">
          <div class="l">
            <p class="img">
              <img
                v-lazy-load data-src="https://download-pa-s3.thethinkacademy.com/message/picture/8601/20240612/1718183484684ZSkkIyJurk.png"
              />
            </p>
            <p class="txt">Your evaluation has been successfully scheduled!</p>
            <p class="txt2">
              The evaluation itinerary has been sent to your email.
            </p>
            <p class="txt3">
              {{ scheduledEventInfo.email }}
            </p>
          </div>
          <div class="r" :class="{ long: reportList.length > 0 }">
            <div class="over">
              <div class="tit">Schedule Information</div>
              <div class="info">
                <p class="p-box">
                  <span class="s1">Child:</span>
                  <span class="s2">{{ scheduledEventInfo.studentName }}</span>
                </p>
                <p class="p-box">
                  <span class="s1">Grade:</span>
                  <span class="s2">{{ scheduledEventInfo.gradeName }}</span>
                </p>
                <p class="p-box">
                  <span class="s1">Email:</span>
                  <span class="s2">{{ scheduledEventInfo.email }}</span>
                </p>
                <p class="p-box">
                  <span class="s1">Phone:</span>
                  <span class="s2">{{ scheduledEventInfo.phone }}</span>
                </p>
                <p class="p-box">
                  <span class="s1">Date:</span>
                  <span class="s2">{{
                    scheduledEventInfo.eventStartTime
                      | resourceDateFormate(timezone, dateFormat)
                  }}</span>
                </p>
                <p class="p-box">
                  <span class="s1">Time:</span>
                  <span class="s2">{{
                    scheduledEventInfo.eventStartTime
                      | resourceDateFormate(timezone, "h:mm a")
                  }}</span>
                </p>
                <p class="p-box">
                  <span class="s1">Location:</span>
                  <span class="s2">{{
                    scheduledEventInfo.eventMethod == 1
                      ? "Zoom Meeting"
                      : scheduledEventInfo.eventMethod == 2
                      ? "in-person"
                      : "Phone Call"
                  }}</span>
                </p>
                <div v-if="scheduledEventInfo.eventMethod == 1" class="p-box">
                  <span class="s1">Link:</span>
                  <div class="s2">
                    <span class="link">{{ scheduledEventInfo.zoomLink }}</span>
                    <div class="copy">
                      <span id="copy" @click="copyLink">Copy</span>
                    </div>
                  </div>
                </div>
                <div v-if="scheduledEventInfo.eventMethod == 2" class="p-box">
                  <span class="s1">Address:</span>
                  <div class="s2">
                    <p>{{ scheduledEventInfo.venueAddress }}</p>
                    <div
                      v-if="
                        !userNetworkInfo.isMainland &&
                        !userNetworkInfo.isChina &&
                        userNetworkInfo.isMainland !== null &&
                        mapData[stuParms.campus]
                      "
                      class="map-if"
                    >
                      <iframe
                        v-lazy-load :data-src="mapData[stuParms.campus].iframe"
                        width="300"
                        height="110"
                        style="border: 0"
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                      />
                    </div>
                    <img
                      v-else
                      class="map"
                      v-lazy-load data-src="https://download-pa-s3.thethinkacademy.com/message/picture/8601/20240612/17181841241692zhOwhtxQu.png"
                    />
                  </div>
                </div>
              </div>
              <div class="info info2">
                <p class="p-box">
                  <span class="s1">Contact Us:</span>
                  <span class="s2"
                    ><span class="link">{{
                      scheduledEventInfo.venueEmail
                    }}</span
                    ><br
                      v-if="
                        scheduledEventInfo.venueEmail &&
                        scheduledEventInfo.venuePhone
                      "
                    />{{ scheduledEventInfo.venuePhone }}</span
                  >
                </p>
                <p class="p-box">
                  <span class="s1">Working Hours:</span>
                  <span class="s2">{{ scheduledEventInfo.venueWorkTime }}</span>
                </p>
              </div>
            </div>
            <div class="su-btn" @click="closeHandler">Confirm</div>
            <div v-if="reportList.length > 0" class="su-btn-box">
              <div
                v-if="reportListNum > 0 && reportList.length > 0"
                class="su-btn-x le"
                @click="zoomHd2('up')"
              >
                previous page
              </div>
              <div
                v-if="reportListNum + 1 < reportList.length"
                class="su-btn-x ri"
                @click="zoomHd2('down')"
              >
                next page
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { oneApi } from 'config/api';
import Clipboard from 'clipboard';
import { setCookies } from 'common/utils';
import { loadScript } from 'common/loadScripts.js'

export default {
  props: {
    show: {
      default: false,
      type: Boolean,
    },
    // 预约诊断|预约专家(1,2)-zoom|in-person-call (1,2,3)
    // 1正常 3专家 4确认信息
    diagnosisInfo: {
      default: () => ({}),
      type: Object,
    },
  },
  data() {
    const { userNetworkInfo } = this.$store.state;
    return {
      env: process.env.runtime === 'prod'
        ? 'prod'
        : (process.env.runtime === 'pre' || process.env.runtime === 'preprod'
          ? "pre"
          : "beta"),
      stage: 1,
      isNew: true,
      stuParms: {
        firstName: "",
        lastName: "",
        gradeId: "",
        campus: "",
        learningGoalIds: [],
        phoneNumber: "",
        email: "",
        phoneAreaCode: "",
        uid: "",
        hasEmail: false,
        hasPhone: false,
      },
      longLat: {
        long: "",
        lat: "",
      },
      campusList: [],
      gradeList: [],
      loading: false,
      loadingBox: false,
      oldStuData: [],
      phoneCodeList: this.$store.state.phoneCodeList,
      lvShow: 0,
      zdNow: 1,
      scheduledEventInfo: {},
      csUrl: "",
      csType: "",
      userNetworkInfo,
      mapData: {
        1: {
          iframe:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d198.3437708108976!2d-122.03282465840212!3d37.306974472441794!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb5e8a49cf095%3A0x3c1d2c68a8d3f2a8!2sThink%20Academy!5e0!3m2!1sen!2s!4v1717128143829!5m2!1sen!2s",
          name: "Cupertino Campus, CA",
          adress: "1081 S De Anza Blvd, San Jose, CA 95129",
        },
        41: {
          iframe:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d396.211311761226!2d-122.10631018433685!3d37.39715116839711!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb0bd7ae096d7%3A0xd76490e9607dbd10!2s4984%20W%20El%20Camino%20Real%2C%20Mountain%20View%2C%20CA%2094040%2C%20USA!5e0!3m2!1sen!2s!4v1717125015754!5m2!1sen!2s",
          name: "Los Altos Campus, CA",
          adress: "4984 W El Camino Real, Mountain View, CA 94040",
        },
        32: {
          iframe:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d332.4045187969011!2d-117.76910570798509!3d33.69327422056555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dcdce25b2a59c9%3A0x3b7c00795d12d610!2s770%20Roosevelt%2C%20Irvine%2C%20CA%2092620%2C%20USA!5e0!3m2!1sen!2s!4v1717125090660!5m2!1sen!2s",
          name: "Irvine Campus, CA",
          adress: "770 Roosevelt, Irvine, CA 92620",
        },
        16: {
          iframe:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d168.05846478754813!2d-122.17085218029256!3d47.62738627210519!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54906cfbebcb76a3%3A0x74dde52547dad42f!2s12729%20Northup%20Way%20%2310%20Bellevue%2C%20WA%2098005%2C%20USA!5e0!3m2!1sen!2s!4v1717127350877!5m2!1sen!2s",
          name: "Bellevue Campus, WA",
          adress: "12729 Northup Way #10 Bellevue, WA 98005",
        },
        22: {
          iframe:
            "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d396.0994033304648!2d-122.1085092!3d37.4183147!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fba6d6e8e8b33%3A0xbc6e2e5dc13f7561!2s4000%20Middlefield%20Rd%2C%20Palo%20Alto%2C%20CA%2094303%2C%20USA!5e0!3m2!1sen!2s!4v1718193120468!5m2!1sen!2s>",
          name: "Pala Alto Campus, CA",
          adress: "4000 Middlefield Rd, Palo Alto, CA 94303",
        },
        349: {
          iframe:
            "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d396.0994033304648!2d-122.1085092!3d37.4183147!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fba6d6e8e8b33%3A0xbc6e2e5dc13f7561!2s4000%20Middlefield%20Rd%2C%20Palo%20Alto%2C%20CA%2094303%2C%20USA!5e0!3m2!1sen!2s!4v1718193120468!5m2!1sen!2s>",
          name: "测试用",
          adress: "测试用",
        },
        4: {
          iframe:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d198.3437708108976!2d-122.03282465840212!3d37.306974472441794!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb5e8a49cf095%3A0x3c1d2c68a8d3f2a8!2sThink%20Academy!5e0!3m2!1sen!2s!4v1717128143829!5m2!1sen!2s",
          name: "Cupertino Campus, CA",
          adress: "1081 S De Anza Blvd, San Jose, CA 95129",
        },
      },
      dateFormat: "",
      clientOptions: "",
      reportList: [],
      reportListNum: 0,
      venueEmail: "",
      venuePhone: "",
      stage3Loading: false,
      loadingTimeOut: null,
      stage3Error: false,
      stage3Null: false,
      objectivesList: [
        {
          id: 1,
          name: 'School Math Enhancement',
        },
        {
          id: 2,
          name: 'Math Progress Acceleration',
        },
        {
          id: 3,
          name: 'Math Competition',
        },
      ],
      existExam: true, // 可以在线诊断
      existCalendly: true, // 可以预约诊断
    };
  },
  computed: {
    logoUrl() {
      return (
        this.$store.state.website.config.logo || this.$t("common.logo.normal")
      );
    },
    userInfo() {
      return this.$store.state.ucenter.user;
    },
    schoolCode() {
      return this.$store.state.schoolCode;
    },
    attribution() {
      return this.$store.state.attribution;
    },
    timezone() {
      return this.$store.state.timezone;
    },
  },
  watch: {
    show: {
      handler(value) {
        if (value) {
          this.init();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // this.init();
    // 学员信息录入弹框曝光
    this.Sensors.track("evaluation_info_pop_up");

    // if (navigator.geolocation) {
    //   navigator.geolocation.getCurrentPosition(this.showmap, this.error);
    // }
  },
  methods: {
    closeHandler() {
      this.stage3Error = false;
      this.stage3Null = false;
      this.stage3Loading = false;
      this.loadingTimeOut && clearTimeout(this.loadingTimeOut);
      window.removeEventListener("message", this.handleCalendlyEvent, true);
      this.reportList = [];
      this.stage = 1;
      this.lvShow = 0;
      this.zdNow = 1;
      this.reportListNum = 0;
      this.$emit("update:show", false);
    },

    async zoomHd2(type) {
      if (type == "up") {
        this.reportListNum--;
      } else {
        this.reportListNum++;
      }
      await this.zoomHd(this.reportList[this.reportListNum], "report");
    },

    async init() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showmap, this.error);
      }
      this.reportList = [];
      const clientOptions = JSON.parse(
        window.localStorage.getItem("clientOptions")
      );
      if (!clientOptions) {
        await this.$store.dispatch("ucenter/getClientOptions", {
          $axios: this.$axios,
        });
      }
      this.clientOptions = JSON.parse(
        window.localStorage.getItem("clientOptions")
      );
      const dateFormatMap = {
        USA: "DD/MM/YYYY",
        UK: "DD/MM/YYYY",
        FR: "DD/MM/YYYY",
        JP: "YYYY/MM/DD",
      };
      this.dateFormat =
        dateFormatMap[this.clientOptions.dateFormat] || "MM/DD/YYYY";
      if (this.diagnosisInfo.type == 4) {
        this.stage = 4;
        this.reportList = JSON.parse(
          decodeURIComponent(this.diagnosisInfo.url)
        );
        await this.zoomHd(this.reportList[this.reportListNum], "tipsList");
        return;
      }
      if (this.diagnosisInfo.type == 3) {
        this.stage = 2;
        this.stuParms.campus = this.diagnosisInfo.campus;
        this.stuParms.uid = this.diagnosisInfo.uid;
        this.stuParms.firstName = this.diagnosisInfo.firstName || "";
        this.stuParms.lastName = this.diagnosisInfo.lastName || "";
        this.stuParms.gradeId = this.diagnosisInfo.gradeId;
        this.stuParms.phoneAreaCode =
          this.$store.state.defaultPhoneCode || this.phoneCodeList[0];
      } else {
        this.loadingBox = true;
        if (!this.phoneCodeList.length) {
          await this.$store.dispatch("requeryBasicData", this.$axios);
          this.phoneCodeList = [...this.$store.state.phoneCodeList];
        }
        this.stuParms.phoneAreaCode =
          this.$store.state.defaultPhoneCode || this.phoneCodeList[0];

        if (this.gradeList.length < 1) {
          const res = await this.$axios.post(
            // oneApi.queryGradesAll,
            oneApi.queryScheduledGrades,
            {},
            { rewritePostBody: true },
          );

          this.gradeList = res?.data || [];
        }
        const useData = await this.$axios.post(
          oneApi.getFamilyStudentsList,
          {},
          { rewritePostBody: true },
        );
        if (useData.code !== 0) {
          this.$ElMessage({
            type: "error",
            message: useData.msg,
            offset: 80,
          });
          this.loadingBox = false;
          return;
        }

        const resData = useData.data.currentAccount;
        if (this.diagnosisInfo.type !== 3) {
          this.stuParms.uid = resData.uid;
          this.stuParms.firstName = resData.firstName;
          this.stuParms.lastName = resData.lastName;
          this.stuParms.gradeId = resData.gradeId
            ? String(resData.gradeId)
            : null;
        }
        // this.stuParms.uid = resData.uid;
        // this.stuParms.firstName = resData.firstName;
        // this.stuParms.lastName = resData.lastName;
        const allData = useData.data.associatedAccount || [];
        allData.unshift(resData);
        this.oldStuData = allData;

        if (
          this.userInfo.firstName ||
          this.userInfo.lastName ||
          this.userInfo.nickName
        ) {
          this.isNew = false;
          if (this.userInfo.attentionEmail) {
            this.stuParms.hasEmail = true;
          } else {
            this.stuParms.hasEmail = false;
          }
          if (this.userInfo.attentionPhone) {
            this.stuParms.hasPhone = true;
          } else {
            this.stuParms.hasPhone = false;
          }
        } else {
          this.isNew = true;
        }
        // if (navigator.geolocation) {
        //   navigator.geolocation.getCurrentPosition(this.showmap, this.error);
        // }
        await this.getXxj();
      }
      // window.addEventListener('message', this.handleCalendlyEvent);
      this.loadingBox = false;
    },
    findRecommendCampus(campusList) {
      return campusList.find(campus => campus.recommend === true);
    },

    getFirstCampusId(campusList) {
      return campusList.length > 0 ? String(campusList[0].venueId) : null;
    },
    handleCalendlyEvent(e) {
      // console.log("预约-回调消息", e.data, e.origin);
      if (this.isCalendlyEvent(e)) {
        if (e.data.event === "calendly.event_scheduled") {
          this.zoomHd(e.data.payload.invitee.uri, "test");
          document.getElementById("SAMPLEdivID").style.display = "none";
        }
        if (e.data.event === "calendly.event_type_viewed") {
          console.log("预约-初始化完成");
          this.stage3Loading = false;
          this.loadingTimeOut && clearTimeout(this.loadingTimeOut);
        }
      }
    },

    // 校验
    async changeHandler() {
      await this.getXxj();
    },

    changeCampus() {
      const campusInfo = this.campusList.find(item => item.venueId === Number(this.stuParms.campus));
      this.existExam = campusInfo.existExam;
      this.existCalendly = campusInfo.existCalendly;
    },

    showmap(position) {
      const cords = position.coords;
      this.longLat.long = cords.longitude;
      this.longLat.lat = cords.latitude;
    },
    error(error) {
      console.log("this.longLatthis.longLat", error);
    },

    // 设置线下教学点
    async getXxj(id) {
      // 寻找学员的年纪和默认教学点
      const gradeId = id || this.stuParms.gradeId
      if (gradeId) {
        const gradeInfo = this.gradeList.find(item => item.gradeId === Number(gradeId));
        if (!gradeInfo) {
          this.stuParms.gradeId = null;
        }
        this.campusList = gradeInfo?.venueInfoList || [];

        // 如果有默认的教学点取默认 没有取第一个
        const recommendCampus = this.findRecommendCampus(this.campusList);
        this.stuParms.campus = recommendCampus
          ? String(recommendCampus.venueId)
          : this.getFirstCampusId(this.campusList);
        // 根据选中教学点 判断是否展示 在线诊断和预约诊断按钮
        if (this.stuParms.campus) {
          const campusInfo = this.campusList.find(item => item.venueId === Number(this.stuParms.campus));
          console.log('设置好的教学点', this.stuParms.campus, campusInfo);
          this.existExam = campusInfo.existExam;
          this.existCalendly = campusInfo.existCalendly;
        }
      } else {
        this.stuParms.campus = null;
      }
    },

    // 去诊断
    async toZd() {
      if (this.loading) return;
      if (this.stuParms.email) {
        const isContinue =
          /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+.([A-Za-z]{2,8})$/.test(
            this.stuParms.email
          );
        if (!isContinue) {
          this.$ElMessage({
            type: "warning",
            message: "Please leave a valid email",
            offset: 80,
          });
          this.loadingBox = false;
          this.loading = false;
          return;
        }
      } else {
        this.$ElMessage({
          type: "warning",
          message: "Please leave a valid email",
          offset: 80,
        });
        this.loadingBox = false;
        this.loading = false;
        return;
      }
      const { reg } = this.stuParms.phoneAreaCode;
      if (this.stuParms.phoneNumber) {
        const isContinue = reg.test(this.stuParms.phoneNumber);
        if (!isContinue) {
          this.$ElMessage({
            type: "warning",
            message: "Please leave a valid phone",
            offset: 80,
          });
          this.loadingBox = false;
          this.loading = false;
          return;
        }
      } else {
        this.$ElMessage({
          type: "warning",
          message: "Please leave a valid phone",
          offset: 80,
        });
        this.loadingBox = false;
        this.loading = false;
        return;
      }
      if (this.stuParms.learningGoalIds.length === 0 && this.schoolCode !== '4401') {
        this.$ElMessage({
          type: 'warning',
          message: 'Please choose Math Learning Goals',
          offset: 80,
        });
        this.loadingBox = false;
        this.loading = false;
        return;
      }
      if (!this.stuParms.campus) {
        this.$ElMessage({
          type: "warning",
          message: "Please choose campus",
          offset: 80,
        });
        this.loadingBox = false;
        this.loading = false;
        return;
      }
      if (!this.stuParms.gradeId) {
        this.$ElMessage({
          type: "warning",
          message: "Please Choose grade",
          offset: 80,
        });
        this.loadingBox = false;
        this.loading = false;
        return;
      }
      if (!this.stuParms.firstName) {
        this.$ElMessage({
          type: "warning",
          message: "Please leave firstName",
          offset: 80,
        });
        this.loadingBox = false;
        this.loading = false;
        return;
      }
      if (!this.stuParms.lastName) {
        this.$ElMessage({
          type: "warning",
          message: "Please leave lastName",
          offset: 80,
        });
        this.loadingBox = false;
        this.loading = false;
        return;
      }
      this.loading = true;
      if (this.lvShow == this.oldStuData.length) {
        await this.addStu();
      } else {
        await this.updateData();
      }

      if (this.oldStuData.length > 1) {
        await this.changeUid(this.stuParms.uid);
      }

      let grade_name = "";
      let lc_name = "";
      this.gradeList.forEach((item) => {
        if (item.gradeId === Number(this.stuParms.gradeId)) {
          grade_name = item.gradeName;
        }
      });
      this.campusList.forEach((item) => {
        if (item.venueId === Number(this.stuParms.campus)) {
          lc_name = item.venueName;
        }
      });
      // 立即诊断按钮点击
      this.Sensors.track("evaluation_info_start_click", {
        grade_name,
        lc_name,
      });

      this.loading = false;
      const evaluationId = await this.queryEvaluationId();
      await this.lzxs(1, evaluationId);
      if (evaluationId) {
        const url = `${window.location.origin}/quiz/evaluation/instruction/${evaluationId}`;
        window.open(url);
      }
    },

    // 去第二步
    async toLv2() {
      if (this.loading) return;
      if (this.stuParms.email) {
        const isContinue =
          /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+.([A-Za-z]{2,8})$/.test(
            this.stuParms.email
          );
        if (!isContinue) {
          this.$ElMessage({
            type: "warning",
            message: "Please leave a valid email",
            offset: 80,
          });
          this.loadingBox = false;
          return;
        }
      } else {
        this.$ElMessage({
          type: "warning",
          message: "Please leave a valid email",
          offset: 80,
        });
        this.loadingBox = false;
        this.loading = false;
        return;
      }
      const { reg } = this.stuParms.phoneAreaCode;
      if (this.stuParms.phoneNumber) {
        const isContinue = reg.test(this.stuParms.phoneNumber);
        if (!isContinue) {
          this.$ElMessage({
            type: "warning",
            message: "Please leave a valid phone",
            offset: 80,
          });
          this.loadingBox = false;
          return;
        }
      } else {
        this.$ElMessage({
          type: "warning",
          message: "Please leave a valid phone",
          offset: 80,
        });
        this.loadingBox = false;
        this.loading = false;
        return;
      }
      if (this.stuParms.learningGoalIds.length === 0) {
        this.$ElMessage({
          type: 'warning',
          message: 'Please choose Math Learning Goals',
          offset: 80,
        });
        this.loadingBox = false;
        this.loading = false;
        return;
      }
      if (!this.stuParms.campus) {
        this.$ElMessage({
          type: "warning",
          message: "Please choose campus",
          offset: 80,
        });
        this.loadingBox = false;
        this.loading = false;
        return;
      }
      if (!this.stuParms.gradeId) {
        this.$ElMessage({
          type: "warning",
          message: "Please Choose grade",
          offset: 80,
        });
        this.loadingBox = false;
        this.loading = false;
        return;
      }
      if (!this.stuParms.firstName) {
        this.$ElMessage({
          type: "warning",
          message: "Please leave firstName",
          offset: 80,
        });
        this.loadingBox = false;
        this.loading = false;
        return;
      }
      if (!this.stuParms.lastName) {
        this.$ElMessage({
          type: "warning",
          message: "Please leave lastName",
          offset: 80,
        });
        this.loadingBox = false;
        this.loading = false;
        return;
      }

      let grade_name = "";
      let lc_name = "";
      this.gradeList.forEach((item) => {
        if (item.gradeId === Number(this.stuParms.gradeId)) {
          grade_name = item.gradeName;
        }
      });
      this.campusList.forEach((item) => {
        if (item.venueId === Number(this.stuParms.campus)) {
          lc_name = item.venueName;
        }
      });
      // 预约诊断按钮点击
      this.Sensors.track("evaluation_info_schedule_click", {
        grade_name,
        lc_name,
      });

      this.loadingBox = true;
      if (this.lvShow == this.oldStuData.length) {
        await this.addStu();
      } else {
        await this.updateData();
      }
      this.stage = 2;
      await this.lzxs(2, 0);
      this.loadingBox = false;
    },

    // 去第三步
    async tolv3() {
      console.log("预约-点击下一步");
      this.stage3Error = false;
      await this.loadCalendlySdk();
      const res = await this.$axios.post(
        oneApi.queryCalendlyInfo,
        {
          venueId: Number(this.stuParms.campus),
          gradeId: Number(this.stuParms.gradeId),
          eventMethod: this.zdNow,
          eventType: this.diagnosisInfo.type == 3 ? 2 : 1,
          learningGoalIds: this.stuParms.learningGoalIds,
        },
        { rewritePostBody: true }
      );
      if (res.code !== 0) {
        this.$ElMessage({
          type: "error",
          message: res.msg,
          offset: 80,
        });
        return;
      }
      // utm_content 分校码-学员id-年级id -教学点id-预约诊断|预约专家(1,2)-zoom|in-person-call (1,2,3)

      this.venueEmail = res.data.venueEmail;
      this.venuePhone = res.data.venuePhone;

      this.stage = 3;
      this.stage3Loading = true;
      this.loadingTimeOut = setTimeout(() => {
        this.stage3Loading = false;
        this.stage3Error = true;
      }, 20000);
      if (!res.data.eventLink) {
        this.stage3Loading = false;
        this.loadingTimeOut && clearTimeout(this.loadingTimeOut);
        this.stage3Null = true;
        return;
      }
      console.log("预约-开始渲染calendly");

      // schoolCode#studentId#gradeId#venueId#eventType#eventMethod#examId#learningGoal
      const utm_content =`${this.schoolCode}#${this.stuParms.uid}#${this.stuParms.gradeId}#${this.stuParms.campus}${this.diagnosisInfo.type == 3 ? "#2#" : "#1#"}${this.zdNow}${this.diagnosisInfo.type == 3 ? `#${this.diagnosisInfo.reportId}` : '#'}#${this.stuParms.learningGoalIds.join()}`;
      const utm_campaign = `event_type=${this.attribution.eventType}&event_id=${this.attribution.eventId}&source_type=${this.attribution.sourceType}&source_id=${this.attribution.sourceId}&source_code=website&media_code=pc_conversion`;
      try {
        console.info("预约-初始化开始");

        Calendly.initInlineWidget({
          url: `${res.data.eventLink}?&utm_source=${
            this.env
          }&utm_content=${escape(utm_content)}&utm_campaign=${escape(
            utm_campaign
          )}&primary_color=FF9F0A&hide_event_type_details=1&hide_gdpr_banner=1`,
          parentElement: document.getElementById("SAMPLEdivID"),
          prefill: {
            name: `${this.stuParms.firstName} ${this.stuParms.lastName}`,
            email: this.stuParms.email || "",
            customAnswers: {
              a1: `${this.stuParms.phoneAreaCode.value}${this.stuParms.phoneNumber}`,
              // a2: this.stuParms.phoneNumber || "",
            },
          },
        });
        window.addEventListener("message", this.handleCalendlyEvent);
      } catch (error) {
        console.error("预约-calendly初始化失败", error);
        this.stage3Loading = false;
        this.loadingTimeOut && clearTimeout(this.loadingTimeOut);
        this.stage3Error = true;
      }
    },

    // 会议回调1
    isCalendlyEvent(e) {
      return (
        e.origin === "https://calendly.com" &&
        e.data.event &&
        e.data.event.indexOf("calendly.") === 0
      );
    },

    // 预约成功
    async zoomHd(url, type = "test") {
      this.csUrl = url;
      this.csType = type;
      this.loadingBox = true;
      this.stage3Error = false;
      const res = await this.$axios.post(
        oneApi.queryScheduledEventInfo,
        {
          scheduledEventUrl: url,
        },
        {
          rewritePostBody: true,
        }
      );
      if (Number(res.code) !== 0) {
        this.$ElMessage({
          type: "error",
          message: res.msg,
          offset: 80,
        });
        this.loadingBox = false;
        this.loading = false;
      }
      if (!res.data) {
        this.stage3Error = true;
        this.loadingBox = false;
        document.getElementById("SAMPLEdivID").style.display = "block";
        document.getElementById("SAMPLEdivID").innerHTML = "";
        return;
      }

      this.loadingBox = false;
      this.scheduledEventInfo = res.data;
      this.stage = 4;

      // 完成预约弹框曝光
      this.Sensors.track("evaluation_schedule_finish_pop_up", {
        grade_name: res.data.gradeName,
        lc_name: res.data.venueName,
      });

      if (type === "test" || (type === "retry" && this.csType === "test")) {
        window.dataLayer.push({
          event: "evaluation_appointment_gtm",
        });
      }
    },

    // 更新信息
    async updateData() {
      const params = {};
      if (this.stuParms.firstName) {
        params.firstName = this.stuParms.firstName;
      }
      if (this.stuParms.lastName) {
        params.lastName = this.stuParms.lastName;
      }
      if (this.stuParms.gradeId) {
        params.gradeId = Number(this.stuParms.gradeId) || null;
      }
      if (this.stuParms.phoneNumber) {
        params.attentionPhone = this.stuParms.phoneNumber;
        params.attentionCountryCode = this.stuParms.phoneAreaCode.value;
      }
      if (this.stuParms.email) {
        params.attentionEmail = this.stuParms.email;
      }
      const res = await this.$axios.post(oneApi.modifyUserInfo, params, {
        rewritePostBody: true,
        uid: String(this.stuParms.uid),
      });
      if (Number(res.code) !== 0) {
        this.$ElMessage({
          type: "error",
          message: res.msg,
          offset: 80,
        });
        this.loadingBox = false;
        this.loading = false;
      }
      const useData = await this.$axios.post(
        oneApi.getFamilyStudentsList,
        {},
        { rewritePostBody: true }
      );
      if (useData.code !== 0) {
        this.$ElMessage({
          type: "error",
          message: useData.msg,
          offset: 80,
        });
        this.loadingBox = false;
        return;
      }
      const resData = useData.data.currentAccount;
      const allData = useData.data.associatedAccount || [];
      allData.unshift(resData);
      this.oldStuData = allData;
    },

    // 切换学生
    async changeStu(item, index, isNew) {
      const newDate = {
        firstName: "",
        lastName: "",
        gradeId: "",
        campus: "",
        learningGoalIds: [],
        phoneNumber: "",
        email: "",
        phoneAreaCode: "",
        uid: "",
        hasEmail: false,
        hasPhone: false,
      };
      newDate.hasEmail = this.stuParms.hasEmail;
      newDate.hasPhone = this.stuParms.hasPhone;
      if (isNew) {
        this.lvShow = index + 1;
        newDate.phoneAreaCode = this.stuParms.phoneAreaCode;
      } else {
        newDate.firstName = item.firstName;
        newDate.lastName = item.lastName;
        if (!item.gradeId) {
          newDate.gradeId = null;
        } else {
          // 从 gradeList 中查找匹配的年级信息
          const findStuGrade = this.gradeList.find((gradInfo) => gradInfo.gradeId === item.gradeId);
          // 如果找到了匹配的年级信息，将其 gradeId 转为字符串赋值给 newDate.gradeId
          // 否则将 newDate.gradeId 设为 null
          newDate.gradeId = findStuGrade ? String(findStuGrade.gradeId) : null;
        }
        newDate.campus = this.stuParms.campus;
        newDate.uid = item.uid;
        newDate.phoneAreaCode = this.stuParms.phoneAreaCode;
        this.lvShow = index;
      }
      this.stuParms = newDate;
      await this.getXxj(newDate.gradeId);
    },

    // 添加学员
    async addStu() {
      if (!this.stuParms.firstName) {
        this.$ElMessage({
          type: "error",
          message: "Please leave firstName",
          offset: 80,
        });
        return;
      }
      if (!this.stuParms.lastName) {
        this.$ElMessage({
          type: "error",
          message: "Please leave lastName",
          offset: 80,
        });
        return;
      }
      if (!this.stuParms.gradeId) {
        this.$ElMessage({
          type: "error",
          message: "Please Choose grade",
          offset: 80,
        });
        return;
      }
      const params = {
        firstName: this.stuParms.firstName,
        lastName: this.stuParms.lastName,
        gradeId: Number(this.stuParms.gradeId) || null,
        email: this.stuParms.email || this.userInfo.email || "",
        nickName: `${this.stuParms.firstName} ${this.stuParms.lastName}`,
      };
      const res = await this.$axios.post(oneApi.addNewStudent, params, {
        rewritePostBody: true,
      });
      // 更新用户信息
      await this.$store.dispatch("ucenter/queryUserBasicInfo", {
        $axios: this.$axios,
        userData: { fillInAttention: false },
      });
      if (Number(res.code) !== 0) {
        this.$ElMessage({
          type: "error",
          message: res.msg,
          offset: 80,
        });
        this.loadingBox = false;
        this.loading = false;
      }
      this.stuParms.uid = res.data.id;
      const useData = await this.$axios.post(
        oneApi.getFamilyStudentsList,
        {},
        { rewritePostBody: true }
      );
      if (useData.code !== 0) {
        this.$ElMessage({
          type: "error",
          message: useData.msg,
          offset: 80,
        });
        this.loadingBox = false;
        return;
      }
      const resData = useData.data.currentAccount;
      const allData = useData.data.associatedAccount || [];
      allData.unshift(resData);
      this.oldStuData = allData;
    },

    // 切换学员登录态
    async changeUid(uid) {
      const data = {
        targetUid: uid,
      };
      const res = await this.$axios.post(oneApi.switchAccount, data, {
        rewritePostBody: true,
      });

      if (Number(res.code) !== 0) {
        this.$ElMessage.error(res.msg);
        this.loadingBox = false;
        return;
      }
      const resData = res.data || {};
      const accessToken = resData.unifiedAccessToken || "";
      this.$store.commit("ucenter/SET_USER", resData);
      setCookies("_official_token", accessToken);
      await this.$store.dispatch("ucenter/queryUserBasicInfo", {
        $axios: this.$axios,
        userData: { fillInAttention: false },
      });
      this.loadingBox = false;
    },

    copyLink() {
      const that = this;
      const referClipboard = new Clipboard("#copy", {
        text: () => that.scheduledEventInfo.zoomLink,
      });
      this.$ElMessage({
        type: "success",
        message: "Success",
        offset: 80,
      });
    },

    // 留资线索
    async lzxs(type, examId) {
      const data = {
        type,
        profile: {},
        crmInfo: {},
      };

      if (this.stuParms.firstName) {
        data.profile.firstName = this.stuParms.firstName;
        data.crmInfo.givenName = this.stuParms.firstName;
      }

      if (this.stuParms.lastName) {
        data.profile.lastName = this.stuParms.lastName;
        data.crmInfo.familyName = this.stuParms.lastName;
      }

      if (this.stuParms.gradeId) {
        data.profile.gradeId = this.stuParms.gradeId;
        data.crmInfo.gradeId = this.stuParms.gradeId;
      }

      if (this.stuParms.learningGoalIds.length) {
        data.crmInfo.learningGoalIds = this.stuParms.learningGoalIds
      }

      if (this.stuParms.phoneNumber) {
        data.crmInfo.areaCode = this.stuParms.phoneAreaCode.value;
        data.crmInfo.phone = this.stuParms.phoneNumber;
      }

      if (this.stuParms.email) {
        data.crmInfo.email = this.stuParms.email;
      }

      if (this.stuParms.uid) {
        data.crmInfo.uid = this.stuParms.uid;
      }
      if (examId) {
        data.crmInfo.examId = Number(examId);
      }
      let zdId = null;
      this.campusList.forEach((e) => {
        if (e.venueId == this.stuParms.campus) {
          zdId = e.venueName;
        }
      });
      data.crmInfo.venueName = zdId;

      const sourceObj = {
        sourceCode: 'website',
        mediaCode: 'pc_conversion',
      }
      const res = await this.$axios.post(oneApi.getScheduleYy, { ...data, ...sourceObj }, {
        rewritePostBody: true,
      });
    },

    // 后退
    backHandler() {
      if (this.stage == 3) {
        document.getElementById("SAMPLEdivID").style.display = "block";
        document.getElementById("SAMPLEdivID").innerHTML = "";
        this.stage3Loading = false;
        this.loadingTimeOut && clearTimeout(this.loadingTimeOut);
        this.stage3Error = false;
        this.stage3Null = false;
        window.removeEventListener("message", this.handleCalendlyEvent, true);
      }
      this.stage -= 1;
    },
    async queryEvaluationId() {
      const res = await this.$axios.post(
        oneApi.scheduledExam,
        {
          gradeId: Number(this.stuParms.gradeId) || null,
          venueId: Number(this.stuParms.campus) || null,
          learningGoalIds: this.stuParms.learningGoalIds || null,
          lat: this.longLat.lat || null,
          lng: this.longLat.long || null,
        },
        { rewritePostBody: true },
      );
      let evaluationId = null;
      // 取recommendExam中的examId
      const recommendExam = res?.data?.recommendExam || null;
      if (recommendExam) {
        evaluationId = recommendExam?.examId || null;
      }
      return evaluationId;
    },
    async loadCalendlySdk() {
      await loadScript({
        src: 'https://assets.calendly.com/assets/external/widget.js',
      })
      console.log('calendly SDK Loaded')
    },
  },
};
</script>
<style lang="scss" scoped>
.normal-dialog {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 2000;
  .black-bg {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    left: 0;
    top: 0;
  }
  .template-box {
    width: 440px;
    min-height: 500px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    box-shadow: 0 8px 25px 0 rgba(0, 0, 0, 0.05);
    background: #fff;
    overflow: hidden;
    &.long {
      width: 820px;
    }
    .header {
      height: 72px;
      padding: 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logo {
        height: 24px;
        img {
          height: 100%;
        }
      }
      .operate-dialog-icon {
        position: relative;
        width: 24px;
        height: 24px;
        cursor: pointer;
        .close-icon {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          &.hover-close-icon {
            z-index: 17;
            display: none;
          }
          img {
            height: 100%;
          }
        }
        &:hover .close-icon.hover-close-icon {
          display: block;
        }
      }
      .back-icon {
        width: 24px;
        height: 24px;
        border-radius: 100%;
        text-align: center;
        line-height: 24px;
        font-size: 8px;
        color: var(--txt-color-lv2);
        cursor: pointer;
        &:hover {
          background: #f5f5f5;
          color: var(--txt-color-lv1);
        }
      }
    }
  }
}
.t1-title {
  padding: 0 24px;
  font-size: 20px;
  font-family: Montserrat-Bold, Montserrat;
  font-weight: bold;
  color: #222222;
  line-height: 24px;
}
.pub-box {
  padding: 0 24px;
  margin-top: 16px;
  p {
    padding-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .half {
      width: 48%;
    }
    ::v-deep .el-select {
      width: 100%;
    }
    ::v-deep .el-input__inner {
      line-height: 50px;
      height: 50px;
      border-radius: 4px;
      border: 1px solid #e6e6e6;
      font-size: 14px;
      font-family: Montserrat-Medium, Montserrat;
      font-weight: 500;
      color: #222222;
      text-align: left;
    }
    ::v-deep .el-input__inner:focus {
      border: 1px solid var(--txt-color-link);
    }
    ::v-deep .el-input-group__prepend {
      padding: 0;
      border: 0;
      width: 0;
    }
    ::v-deep #update_phone_select {
      border: 0;
      padding-left: 20px;
      &:focus {
        border: 0;
      }
    }
    ::v-deep .phone-code-input {
      .el-input__inner {
        padding-left: 80px;
      }
      .phone-area-code-dropdown {
        left: 0 !important;
        top: 50px !important;
        position: absolute !important;
        width: 392px !important;
        .phone-area-code-option .select-line {
          position: relative;
          .area-code {
            position: absolute;
            right: 0;
            top: 0;
          }
        }
      }
    }
    ::v-deep .phone-code-select {
      width: 80px;
      background: transparent !important;
      border-color: transparent;
      border-radius: 0;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      margin: 0;
      padding: 0;
    }
  }
  .btn-box {
    padding: 20px 0 24px;
    display: block;
    .s2 {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 16px;
      height: 50px;
      background: rgba(255, 159, 10, 0.1);
      border-radius: 25px;
      text-align: center;
      font-size: 12px;
      font-family: Montserrat-Bold, Montserrat;
      font-weight: bold;
      color: var(--txt-color-link);
      cursor: pointer;
      &:hover {
        background: #f5eada;
      }
      &.hide {
        background: #fff5e7;
        &:hover {
          background: #fff5e7;
        }
      }
      .loading {
        width: 20px;
        height: 20px;
        display: inline-block;
        vertical-align: top;
        margin: 0 10px 0 0;
        background: url("https://download-pa-s3.thethinkacademy.com/message/picture/8601/20240612/17181840828425eeHu6pFRu.png")
          0 0/ 20px auto no-repeat;
        animation: around 1s linear infinite;
      }
    }
    .s1 {
      height: 60px;
      background: var(--txt-color-link);
      border-radius: 30px;
      font-size: 16px;
      line-height: 60px;
      font-family: Montserrat-Bold, Montserrat;
      font-weight: bold;
      color: #ffffff;
      text-align: center;
      display: block;
      cursor: pointer;
    }
  }
  ::v-deep .math-learning-goals-select .el-select__tags{
    flex-wrap: nowrap;
    // overflow-x: auto;
    padding-left: 15px;
    -ms-overflow-style: none;  /* IE和Edge */
    scrollbar-width: none;  /* Firefox */
  }
  ::v-deep .math-learning-goals-select .el-select__tags > span{
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
  }
  ::v-deep .math-learning-goals-select .el-select__tags > span::-webkit-scrollbar {
    display: none;  /* Chrome、Safari和Opera */
  }
  ::v-deep .math-learning-goals-select .el-select__tags .el-tag {
    flex-shrink: 0;
    margin: 0;
    .el-select__tags-text {
      font-size: 14px;
      color: #222222;
      font-family: 'Montserrat-Medium, Montserrat';
      font-weight: 500;
    }
  }
  ::v-deep .math-learning-goals-select .el-tag__close {
    display: none;
  }
  ::v-deep .math-learning-goals-select .el-tag {
    background: none;
    border: none;
    padding: 0;
    color: inherit;
  }
  ::v-deep .math-learning-goals-select .el-tag:not(:last-child)::after {
    content: '，';
  }
}
@keyframes around {
  to {
    transform: rotate(360deg);
  }
}
.loading-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 20;
  left: 0;
  top: 0;
  background: rgba(244, 246, 250, 0.8);
  .loading-icon {
    text-align: center;
    position: absolute;
    padding: 30px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    span {
      width: 32px;
      height: 32px;
      display: inline-block;
      background: url(data:image/png;base64,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);
      background-size: 32px 32px;
      animation: around 1s linear infinite;
    }
    p {
      color: rgba(162, 170, 184, 1);
    }
  }
}
.stu-list {
  overflow: hidden;
  overflow-x: auto;
  border-bottom: 1px solid #e6e6e6;
  white-space: nowrap;
  margin: 5px 24px 0;
  &::-webkit-scrollbar {
    height: 0;
  }
  .stu-box {
    display: inline-flex;
    padding: 0 12px;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: Montserrat-SemiBold, Montserrat;
    font-weight: 600;
    color: rgba(34, 34, 34, 0.4);
    line-height: 16px;
    border-bottom: 2px solid #fff;
    margin-right: 12px;
    vertical-align: top;
    height: 40px;
    cursor: pointer;
    img {
      width: 20px;
      height: 20px;
      border: 1px solid #ffffff;
      margin-right: 4px;
    }
    &.on {
      color: var(--txt-color-link);
      border-bottom: 2px solid var(--txt-color-link);
    }
    &:last-child {
      margin-right: 0;
    }
    &.new {
      .icon {
        width: 20px;
        height: 20px;
        margin-right: 4px;
        background: url("https://download-pa-s3.thethinkacademy.com/message/picture/8601/20240612/1718183768709elZIwJfAt6.png")
          0 0/ 20px auto no-repeat;
      }
      &.on {
        .icon {
          background: url("https://download-pa-s3.thethinkacademy.com/message/picture/8601/20240612/1718183873116qxkzwNoqlR.png")
            0 0/ 20px auto no-repeat;
        }
      }
    }
  }
}
.zd-main {
  padding: 0 20px;
  margin-top: 20px;
  display: flex;
  width: 100%;
  height: 400px;
  align-items: center;
  justify-content: space-between;
  &.zd-main-v1 {
    .pub-zd {
      width: 100%;
    }
  }
  .pub-zd {
    width: 49%;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #e6e6e6;
    cursor: pointer;
    .img-box,
    .map-box {
      width: 100%;
      height: 320px;
      display: flex;
      align-items: center;
      justify-content: center;
      .map {
        width: 340px;
        height: 220px;
      }
    }
    .change-btn {
      height: 80px;
      border-top: 1px solid #e6e6e6;
      display: flex;
      margin: 0 24px;
      align-items: center;
      .icon {
        width: 20px;
        height: 20px;
        margin-right: 8px;
        background: url("https://download-pa-s3.thethinkacademy.com/message/picture/8601/20240612/1718183929184aZZvlUseu8.png")
          0 0/ 20px auto no-repeat;
      }
      .txt {
        flex: 1;
        font-size: 14px;
        font-family: Montserrat-SemiBold, Montserrat;
        font-weight: 600;
        color: #222222;
        line-height: 18px;
        span {
          font-size: 12px;
          font-family: Montserrat-Medium, Montserrat;
          font-weight: 500;
          color: rgba(34, 34, 34, 0.8);
          line-height: 14px;
          margin-top: 4px;
        }
      }
    }
    &.zoom {
      img {
        width: 166px;
        height: auto;
      }
    }
    &.zj {
      img {
        width: 166px;
        height: auto;
      }
    }
    &.online {
      img {
        width: 160px;
        height: auto;
      }
    }
    &.on {
      background: #fffdf9;
      border: 1px solid var(--txt-color-link);
      .change-btn {
        border-top: 1px solid rgba(255, 159, 10, 0.4);
        .icon {
          background: url("https://download-pa-s3.thethinkacademy.com/message/picture/8601/20240612/1718184017327U518scVF7S.png")
            0 0/ 20px auto no-repeat;
        }
      }
    }
  }
}
.zd-big-btn {
  padding: 20px 0;
  text-align: center;
  cursor: pointer;
  span {
    width: 392px;
    height: 60px;
    background: var(--txt-color-link);
    border-radius: 30px;
    display: inline-block;
    vertical-align: top;
    font-size: 16px;
    font-family: Montserrat-Bold, Montserrat;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    line-height: 60px;
  }
}
.schedulePage {
  /* width: 402px; */
  height: 550px;
  position: relative;
  box-shadow: 0 5px 8px 0 hsla(0, 0%, 71%, 0.2);
  padding-bottom: 60px;
  .bw-box {
    height: 100%;
    overflow: hidden;
    margin: 0 100px;
    position: relative;
    &:after {
      content: "";
      width: 100%;
      height: 40px;
      background: #fff;
      position: absolute;
      left: 0;
      bottom: 1px;
      z-index: 111;
    }
  }
  .cs-btn {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3000;
    padding-bottom: 80px;
    .cs-img {
      height: 50px;
      text-align: center;
      img {
        width: 50px;
        height: 50px;
      }
    }
    .cs-txt {
      font-size: 16px;
      font-family: Montserrat-SemiBold, Montserrat;
      font-weight: 600;
      color: #222222;
      line-height: 19px;
      text-align: center;
      margin-top: 16px;
    }
    .cs-btn2 {
      text-align: center;
      margin-top: 24px;
      span {
        width: 140px;
        height: 40px;
        background: var(--txt-color-link);
        border-radius: 20px;
        display: inline-block;
        vertical-align: top;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        font-family: Montserrat-Bold, Montserrat;
        font-weight: bold;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
  .stage3-bottom {
    font-family: Montserrat-Medium, Montserrat;
    font-weight: 500;
    color: #222222;
    line-height: 18px;
    position: absolute;
    left: 20px;
    bottom: 20px;
    right: 20px;
    padding-top: 15px;
    border-top: 1px solid #eee;
    z-index: 222;
    span {
      color: var(--txt-color-link);
      text-decoration: underline;
    }
  }
  .stage3-loading,
  .stage3-null,
  .stage3-error {
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #efefef;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding-bottom: 75px;
    height: 100%;
  }
  .stage3-loading {
    .stage3-loading-icon {
      border-radius: 10px;
      span {
        width: 50px;
        height: 50px;
        display: inline-block;
        background: url(data:image/png;base64,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);
        background-size: 50px 50px;
        animation: around 1s linear infinite;
      }
    }
    .stage3-loading-text {
      margin-top: 14px;
      font-size: 16px;
      font-family: Montserrat-Regular, Montserrat;
      font-weight: 400;
      color: #222222;
    }
  }
  .stage3-null {
    .stage3-null-img {
      width: 197px;
      height: 140px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .stage3-null-text {
      max-width: 520px;
      margin-top: 16px;
      font-size: 16px;
      font-family: Montserrat-Medium, Montserrat;
      font-weight: 500;
      color: #222222;
      line-height: 19px;
      text-align: center;
    }
    .stage3-null-btn {
      margin-top: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      width: 290px;
      height: 40px;
      background: var(--txt-color-link);
      border-radius: 20px;
      font-size: 16px;
      font-family: Montserrat-Bold, Montserrat;
      font-weight: bold;
      color: #ffffff;
    }
  }
  .stage3-error {
    .stage3-error-img {
      width: 197px;
      height: 140px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .stage3-error-text {
      max-width: 520px;
      margin-top: 16px;
      font-size: 16px;
      font-family: Montserrat-Medium, Montserrat;
      font-weight: 500;
      color: #222222;
      line-height: 19px;
      text-align: center;
    }
    .stage3-error-btn {
      margin-top: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      width: 140px;
      height: 40px;
      background: var(--txt-color-link);
      border-radius: 20px;
      font-size: 16px;
      font-family: Montserrat-Bold, Montserrat;
      font-weight: bold;
      color: #ffffff;
    }
  }
}
#SAMPLEdivID,
#OKPage {
  width: 998px;
  position: absolute;
  left: -185px;
  top: -140px;
  bottom: 0px;
  right: 0;
  border-radius: 4px;
}
#OKPage {
  display: none;
}
.succ-box {
  display: flex;
  height: 528px;
  padding: 20px 0;
  align-items: center;
  justify-content: space-between;
  .l {
    width: 360px;
    margin: 0 20px 20px 20px;
    height: 510px;
    background: #fff9ef;
    border-radius: 4px;
    border: 1px solid rgba(255, 159, 10, 0.2);
    padding: 0 40px;
    .img {
      padding-top: 158px;
      text-align: center;
      img {
        width: 50px;
        height: 50px;
      }
    }
    .txt {
      font-size: 18px;
      font-family: Montserrat-Bold, Montserrat;
      font-weight: bold;
      color: #222222;
      line-height: 22px;
      text-align: center;
      margin-top: 16px;
    }
    .txt2 {
      font-size: 14px;
      font-family: Montserrat-Medium, Montserrat;
      font-weight: 500;
      color: #222222;
      line-height: 18px;
      margin-top: 36px;
    }
    .txt3 {
      font-size: 14px;
      font-family: Montserrat-Regular, Montserrat;
      font-weight: 400;
      color: var(--txt-color-link);
      line-height: 18px;
      margin-top: 12px;
    }
  }
  .r {
    flex: 1;
    height: 528px;
    margin-right: 20px;
    padding-bottom: 100px;
    position: relative;
    &.long {
      padding-bottom: 150px;
      .su-btn {
        bottom: 70px;
      }
      .su-btn-box {
        position: absolute;
        width: 100%;
        height: 30px;
        left: 0;
        bottom: 20px;
        text-align: right;
        .su-btn-x {
          display: inline-block;
          vertical-align: top;
          min-width: 110px;
          line-height: 28px;
          color: var(--txt-color-link);
          text-align: center;
          border-radius: 15px;
          margin: 0 0 0 20px;
          border: 1px solid var(--txt-color-link);
          height: 30px;
          overflow: hidden;
          padding: 0 20px;
          white-space: nowrap;
          cursor: pointer;
        }
      }
    }
    .over {
      overflow: hidden;
      overflow-y: auto;
      height: 100%;
    }
    .tit {
      font-size: 14px;
      font-family: Montserrat-Bold, Montserrat;
      font-weight: bold;
      color: #222222;
      line-height: 20px;
      position: relative;
      padding-left: 10px;
      &::before {
        content: "";
        width: 3px;
        height: 12px;
        background: var(--txt-color-link);
        border-radius: 2px;
        position: absolute;
        left: 0;
        top: 3px;
      }
    }
    .info {
      .p-box {
        margin-top: 12px;
        display: flex;
        font-size: 14px;
        font-family: Montserrat-Medium, Montserrat;
        font-weight: 500;
        color: #222222;
        line-height: 18px;
        .s1 {
          width: 90px;
        }
        .s2 {
          flex: 1;
          word-break: break-word;
          overflow: hidden;
          .map-if {
            margin-top: 10px;
          }
          .link {
            color: var(--txt-color-link);
            // cursor: pointer;
            text-decoration: underline;
            word-break: break-all;
            // &:hover {
            //   text-decoration: none;
            // }
          }
          .map {
            width: 100%;
            margin-top: 8px;
          }
          .copy {
            margin-top: 12px;
            cursor: pointer;
            span {
              width: 56px;
              height: 26px;
              background: var(--txt-color-link);
              border-radius: 18px;
              display: inline-block;
              vertical-align: top;
              line-height: 25px;
              text-align: center;
              font-size: 12px;
              font-family: Montserrat-SemiBold, Montserrat;
              font-weight: 600;
              color: #ffffff;
            }
          }
        }
      }
      &.info2 {
        margin-top: 16px;
        border-top: 1px solid #e6e6e6;
      }
    }
    .su-btn {
      position: absolute;
      bottom: 20px;
      left: 0;
      height: 60px;
      background: var(--txt-color-link);
      border-radius: 30px;
      width: 100%;
      font-size: 16px;
      font-family: Montserrat-Bold, Montserrat;
      font-weight: bold;
      color: #ffffff;
      text-align: center;
      line-height: 60px;
      cursor: pointer;
    }
  }
}
</style>
